import type { CategoryItem } from '@/mocks/categories';

interface CategoryHeroProps {
  category: CategoryItem;
}

export default function CategoryHero({ category }: CategoryHeroProps) {
  return (
    <header className="relative w-full overflow-hidden rounded-lg border border-background-200">
      <img
        src={category.image}
        alt={`${category.name}栏目封面 - 深夜爆料`}
        title={`${category.name} 深夜爆料 栏目封面`}
        className="absolute inset-0 h-full w-full object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950 via-background-950/80 to-background-950/30"></div>
      <div className="relative px-6 py-10 md:px-10 md:py-14">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-950">
            <i className={`${category.icon} text-xl`}></i>
          </span>
          <span className="text-[10px] tracking-[0.24em] text-primary-300">{category.english}</span>
        </div>
        <h1 className="mt-5 font-heading text-3xl font-black text-foreground-50 md:text-4xl">
          {category.name}
        </h1>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-300 md:text-base">
          {category.description}
        </p>
        <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 text-xs text-foreground-400">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-article-line text-primary-400"></i>
            已发 {category.count} 条
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-flashlight-line text-primary-400"></i>
            持续跟进首发线索
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line text-primary-400"></i>
            双重交叉核实
          </span>
        </div>
      </div>
    </header>
  );
}